import { render } from "./PDFJSViewer.vue?vue&type=template&id=f5008f90&scoped=true"
import script from "./PDFJSViewer.vue?vue&type=script&lang=js"
export * from "./PDFJSViewer.vue?vue&type=script&lang=js"

import "./PDFJSViewer.vue?vue&type=style&index=0&id=f5008f90&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f5008f90"

export default script